import React from "react";
import { Sets } from "../../workout/types";
import { Box, Typography } from "@mui/material";
import dayjs from "dayjs";
import WorkoutHistorySet from "./WorkoutHistorySet";
import { ExerciseTypeExtra, ExerciseTypeSet, Units } from "../../../constants";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: 20,
  },
  completedAt: {
    fontWeight: 500,
    fontSize: 14,
    color: theme.palette.text.secondary,
  },
}));

interface IWorkoutSetTable {
  sets: Sets[];
  completedAt?: string;
  exerciseTypeSet: ExerciseTypeSet;
  exerciseTypeExtraMeasurement?: ExerciseTypeExtra;
  units: Units;
}

const WorkoutSetTable = ({
  sets,
  completedAt,
  exerciseTypeSet,
  units,
  exerciseTypeExtraMeasurement,
}: IWorkoutSetTable) => {
  const s = useStyles();

  return (
    <Box className={s.root}>
      {completedAt && (
        <Typography className={s.completedAt}>
          {dayjs(completedAt).format("MMMM D, YYYY")}
        </Typography>
      )}
      {sets?.map((set, index) => (
        <WorkoutHistorySet
          key={index}
          set={set}
          setNumber={index}
          typeExtraMeasurement={exerciseTypeExtraMeasurement}
          exerciseTypeSet={exerciseTypeSet}
          units={units}
        />
      ))}
    </Box>
  );
};

export default WorkoutSetTable;
